(function($) {

	$(document).ready(function(){

		//stop if that's not subscription page
		if ($('.portal-upgrade-with-deal').length == 0){
			return false;
		}


		//detect best package id
		var best_package_id = false;
		if ($('.information-banner').length > 0){
			best_package_id = $('.information-banner').attr('data-best-pid');
		}
		
		var default_payment_method = $('.payment-method').first().attr('data-payment-method');
		console.log(default_payment_method);

		var saved_state = {
			'pid': default_package_id,
			'payment_method': default_payment_method
		}

		function setSavedProperty(key, value){
			saved_state[key] = value;
			console.log(saved_state);
		}

		//here we restore saved stuff or set the default state
		function restoreSavedState(){
			console.log(saved_state);

			//set the saved product
			if (!(saved_state.pid in packages) || 
				$('.package-single.available[data-pid="'+saved_state['pid']+'"]').length == 0){
				setSavedProperty('pid', default_package_id);
			}
			$('.package-single.available[data-pid="'+saved_state['pid']+'"]').click();

			//set the payment method chosen
			if ($('.payment-method[data-payment-method="'+saved_state['payment_method']+'"]').length == 0){
				setSavedProperty('payment_method', default_payment_method);
			}
			$('.payment-method[data-payment-method="'+saved_state['payment_method']+'"]').click();
		}

		function fillOrderDetails(){
			//set default packge id if nothing is found in array
			if (!(saved_state.pid in packages)){
				setSavedProperty('pid', Object.keys(packages)[0]);
			}
			var package_details = packages[saved_state.pid];
			console.log(package_details);
			var p_container = $('.payment-overview');
			//fill in full-price plan details
			p_container.find('.selectedplan .left .data').html(package_details['plan']);
			p_container.find('.selectedplan .right .data').html(package_details['full_price_formatted']);

			//fill in discount details
			p_container.find('.discount .left .data').html(package_details['discount']);
			p_container.find('.discount .right .data').html(package_details['savings_formatted']);

			//fill in VAT NL details
			p_container.find('.vat .right .data').html(package_details['vat_formatted']);

			//fill in total
			p_container.find('.total .right .data').html(package_details['price_formatted']);
			
		}

		$('.package-single.available').click(function(event){
			event.stopPropagation();
			$('.package-single').removeClass('package-active');
			$(this).addClass('package-active');
			package_id = $(this).attr('data-pid');
			clearCoupon();
			console.log('current pid='+package_id);
			setSavedProperty('pid', package_id);
			fillOrderDetails();

			if (packages[package_id].hasOwnProperty('payment_hide_full_price') &&
				packages[package_id].payment_hide_full_price){
				$('.payment-overview .selectedplan').hide();
			} else {
				$('.payment-overview .selectedplan').show();
			}

			if (packages[package_id].hasOwnProperty('payment_hide_discount') &&
				packages[package_id].payment_hide_discount){
				$('.payment-overview .discount').hide();
			} else {
				$('.payment-overview .discount').show();
			}

			if (best_package_id){
				if (package_id == best_package_id){
					$('.information-banner').hide();
				} else {
					$('.information-banner').show();
				}
			}
		});

		//for special package only
		$('.special-deal').click(function(){
			console.log('special deal container clicked');
			$(this).find('.package-single.available').click();
		});
		
		$('.package-mh').matchHeight();
		$('.payment-method').matchHeight();

		var submit_form = $("#submit-order-form");
		var submit_form_btn = $("#submit-order-form").find('button[type="submit"]');
		submit_form.submit(function(){
			console.log('form submitted');

			//check valid pid
			if (!(saved_state.pid in packages)){
				setSavedProperty('pid', default_package_id);
			}

			//check valid payment option
			if ($('.payment-method[data-payment-method="'+saved_state['payment_method']+'"]').length == 0){
				setSavedProperty('payment_method', default_payment_method);
			}

			//if all is good - append hidden fields to form
			var pid_fld = $('<input type="hidden" name="pid">').val(saved_state.pid);
			var payment_method_fld = $('<input type="hidden" name="payment_method">').val(saved_state.payment_method);
			submit_form
				.append(pid_fld)
				.append(payment_method_fld);

			console.log('submitting a form');
			submit_form_btn.prop('disabled', true);
			this.submit();
		});

		$('.payment-method').click(function(){
			//$('.creditcard-fields').slideUp();
			$('.payment-method-inner').removeClass('active');
			$(this).find('.payment-method-inner').addClass('active');
			var payment_method = $(this).attr('data-payment-method');
			setSavedProperty('payment_method', payment_method);

			//displaying inner options for methods
			submit_form_btn.prop('disabled', false);

			//special placement for BT button
			if (payment_method == 'braintree'){
				submit_form_btn.hide();
				$(braintree_pp_button_selector).show();
				console.log('showing PP button');
			} else {
				submit_form_btn.show();
				$(braintree_pp_button_selector).hide();
				console.log('hiding PP button');
			}

			$('.inner-method').hide();
			if ($('.inner-method[data-payment-method="'+payment_method+'"]').length > 0){
				//special check for BT
				if (payment_method == 'braintree'){
					if (braintree_method_confirmed){
						submit_form_btn.prop('disabled', false);
					} else {
						submit_form_btn.prop('disabled', true);
					}
				}

				$('.inner-method[data-payment-method="'+payment_method+'"]').show();
			}
		});


		$.fn.enterKey = function (fnc) {
			return this.each(function () {
				$(this).keypress(function (ev) {
					var keycode = (ev.keyCode ? ev.keyCode : ev.which);
					if (keycode == '13') {
						fnc.call(this, ev);
					}
				})
			})
		}
		$('.coupon-toggle').click(function(){
			$(this).toggleClass('active');
			return false;
		});
		submit_form.find("[name='coupon']").on('keyup keypress', function(e) {
			var keyCode = e.keyCode || e.which;
			if (keyCode === 13) { 
			e.preventDefault();
				return false;
			}
		});
		var coupon_input = submit_form.find('[name="coupon"]');
		var coupon_val = coupon_input.val();
		coupon_input.enterKey(function(){
			checkCoupon();
			coupon_val = coupon_input.val();
			return false;
		});
		coupon_input.blur(function(){
			if (coupon_input.val() != coupon_val){
				checkCoupon();
			}
		});

		function clearCoupon(){
			$('.coupon-container .help-block.error').hide();
			$('.coupon-container input').val('');
		}

		function checkCoupon(){
			var error_message = $('.coupon-container .help-block.error');
			var voucher = coupon_input.val();

			error_message.hide();
			if(voucher == ''){
				
			}
			else if (voucher.trim() != ""){
				$.ajax({
					method: "POST",
					url: "getsignupvoucher.php",
					dataType: 'json',
					data: { voucher: voucher, pid: saved_state.pid }
				})
				.done(function(data) {
					console.log(data);
					if (data.voucher_found){

						var discounted_package = data.package;
						discounted_package['plan'] = packages[saved_state.pid]['plan'];
						discounted_package['next_bill_date'] = packages[saved_state.pid]['next_bill_date'];
						discounted_package['website-name'] = packages[saved_state.pid]['website-name'];

						//add new package to array
						packages[discounted_package.pid] = discounted_package;

						//select new package
						setSavedProperty('pid', discounted_package.pid);
						fillOrderDetails();
											
					} else {
						error_message.show();
					}
				});
			}
		}


		if (typeof unpaid_package_id !== 'undefined') {
			setSavedProperty('pid', unpaid_package_id);
		}

		restoreSavedState();

		if (typeof unpaid_coupon !== 'undefined') {
			if (unpaid_coupon != ""){
				submit_form.find("[name='coupon']").val(unpaid_coupon);
				$('.coupon-toggle').click();
				checkCoupon();
			}
		}
		
	});

})(jQuery);